import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import ModalDialog from '../../../../components/layouts/ModalDialog'
import { authHeader, tableHeadersFields } from '../../../../utils'
import axios from 'axios'
import { ERROR, SET_SUCCESS } from '../../../../store/types'
import { clearUpdatedSubject } from '../../../../store/actions/subjectsActions'
import EditSubject from '../../../../components/partials/subjects/EditSubject'
import Loader from '../../../../components/elements/Loader'
import PlusIcon from '../../../../components/elements/icons/PlusIcon'
import ClassTeacherAssignment from '../../../../components/partials/subjects/ClassTeacherAssignment'
import EmptyState from '../../../../components/elements/EmptyState'
import TrashIcon from '../../../../components/elements/icons/TrashIcon'
import RecordAssessment from '../../../../components/partials/subjects/RecordAssessment'
import { fetchAssessmentRecords } from '../../../../store/actions/assessmentsActions'
import DataTable from '../../../../components/elements/DataTable'
import AssessmentsFilters from '../../../../components/elements/filters/AssessmentsFilters'
import ArrowUpTrayIcon from '../../../../components/elements/icons/ArrowUpTrayIcon'
import ChevronIcon from '../../../../components/elements/icons/ChevronIcon'
import StaffTableSnippet from '../../../../components/partials/staff/StaffTableSnippet'
import ApplicantTableSnippet from '../../../../components/partials/applications/ApplicantTableSnippet'
import PencilSquareIcon from '../../../../components/elements/icons/PencilSquareIcon'


const SubjectDetails = () => {
  const { subjectId } = useParams()
  const dispatch = useDispatch()
  const subjectsSelector = useSelector(state => state.subjects)
  const [loading, setLoading] = useState(true)
  const [subjectDetails, setSubjectDetails] = useState(null)
  const [reload, setReload] = useState(0)
  
  useEffect(() => {
    const getSubjectDetails = async () => {
      try {
        const headers = authHeader()
        setLoading(true)
        const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/subjects/${subjectId}?expand=classes.teachers,classes.class`, { headers })            
        setSubjectDetails(response.data.data)
        setLoading(false)
      } catch (error) {
        console.log(error)
        dispatch({
          type: ERROR,
          error
        })
        setLoading(false)
      }
    }  

    getSubjectDetails()

    if(subjectsSelector.updatedSubject && subjectsSelector.updatedSubject !== null) {
      setUpdatingSubject(false)
      dispatch(clearUpdatedSubject())
    }
  
    return () => {
      
    }
  }, [dispatch, subjectId, subjectsSelector.updatedSubject, reload])

  const [assessmentPaginaton, setAssessmentPaginaton] = useState({
    page: 1,
    perPage: 25
  })
  const [assessmentFilters, setAssessmentFilters] = useState(`subject=${subjectId}`)
  const assessmentsSelector = useSelector(state => state.assessments)

  useEffect(() => {    
    dispatch(fetchAssessmentRecords(assessmentFilters, assessmentPaginaton.page, assessmentPaginaton.perPage))

    return () => {
      
    }
  }, [assessmentFilters, assessmentPaginaton.page, assessmentPaginaton.perPage, dispatch])

  const [updatingSubject, setUpdatingSubject] = useState(false)  

  const [activeClass, setActiveClass] = useState('')
  const [assigningTeacher, setAssigningTeacher] = useState(false)

  const openTeacherAssignment = (className) => {
    setActiveClass(className)
    setTimeout(() => {
      setAssigningTeacher(true)
    }, 200);
  }

  const closeTeacherAssignment = () => {
    setAssigningTeacher(false)
    setTimeout(() => {
      setActiveClass('')
    }, 200);
  }

  const [removnigTeacher, setRemovingTeacher] = useState(null)

  const removeTeacherAssignment = async (teacherIndex, teacher, classId ) => {
    if(window.confirm('This teacher will be removed as a teacher for this class. Please confirm to continue.')){
      try {
        const payload = {
          teacher,
          class: classId
        }
        const headers = authHeader()
        setRemovingTeacher(teacherIndex)
        await axios.post(`${process.env.REACT_APP_BASE_URL}/subjects/${subjectId}/remove-teacher`, payload, {headers})
        setRemovingTeacher(null)
        dispatch({
            type: SET_SUCCESS,
            payload: 'Class teacher removed successfully'
        })
        setReload(reload+1)
      } catch (error) {
        setRemovingTeacher(null)
        dispatch({
          type: ERROR,
          error
      })
    }}
  }

  const [recordingAssessment, setRecordingAssessment] = useState(false)

  const transactionColumnWidths = {
    student: 'w-3/12',
    recordedBy: 'w-3/12',
    assessment: 'w-3/12',
    score: 'w-1/12',
    dateRecorded: 'w-2/12',
  }
      
  const tableOptions = {
    selectable: false,
    clickableRows: true,
    rowAction: (index)=>{}
  }
  
  const columnDataStyles = {}

  const cleanupData = (dataSet) => {
    if(!dataSet) return []
    const data = []

    dataSet.forEach((item, itemIndex) => {
        data.push(
            {
              student: <ApplicantTableSnippet applicant={item.student} showAdmissionNumber={true} />,
              recordedBy: <StaffTableSnippet staff={item.recordedBy} hidePhoto />,
              score:
              <p className='font-space-grotesk font-medium text-[16px]'>
                <span className={`font-space-grotesk p-[5px] mr-[10px] rounded text-[14px] 
                  ${item.percentageScore >= 70 && 'bg-green-100 text-green-800' }
                  ${item.percentageScore >= 50 && item.percentageScore < 70 && 'bg-gray-100 text-gray-800' }
                  ${item.percentageScore < 50 && 'bg-red-100 text-red-800' }
                `}>
                  {item.percentageScore}%
                </span>
                {item.score}/<span className='text-gray-400'>{item.outOf}</span> 
              </p>,
              assessment: <p className='text-sm'>{item.assessment?.name}
              </p>,
              dateRecorded: `${new Date(item.createdAt).toDateString()} - ${new Date(item.createdAt).toLocaleTimeString()}`,
            },
        )
    })

    return data
  }

  const [showClasses, setShowClasses] = useState(false)
  // const [showAssessments, setShowAssessments] = useState(false)
  
  return (
    <>
      {loading ? <Loader /> : 
        <div className='w-full relative'>
          <button onClick={()=>{setUpdatingSubject(true)}} className='absolute -top-4 right-0 rounded px-4 py-3 mt-4 text-sm text-vcm-purple bg-vcm-light-purple transition duration-200 w-[200px] border border-vcm-purple hover:bg-gray-200 flex items-center justify-center gap-x-2'>
            <PencilSquareIcon className={`w-5 h-5`} />
            Edit Subject Details
          </button>
          {/* <div className='w-full flex gap-x-[20px] gap-y-[20px] mb-[20px]'> */}
            <div className='w-1/3 mb-[20px]'>
              <label className='text-xs text-gray-500 block mb-[5px]'>Subject</label>
              <p className='text-gray-600 text-sm'>{subjectDetails?.name}</p>
            </div>
            {subjectDetails?.shortName !== '' && <div className='w-1/3 mb-[20px]'>
              <label className='text-xs text-gray-500 block mb-[5px]'>Subject Short Name</label>
              <p className='text-gray-600 text-sm'>{subjectDetails?.shortName}</p>
            </div>}
            {subjectDetails?.description !== '' && <div className='w-1/3 mb-[20px]'>
              <label className='text-xs text-gray-500 block mb-[5px]'>Description</label>
              <p className='text-gray-600 text-sm'>{subjectDetails?.description}</p>
            </div>}
          {/* </div> */}

          <div className='w-full mb-[20px] pt-[20px]'>
            <div className='w-full mb-[20px] pt-[20px] mt-[20px]'>
              <div className='flex items-start justify-between border-b border-gray-300 mb-[40px] pb-[10px]'>
                <div className='w-2/3'>
                  <h3 className='text-[15px] font-space-grotesk text-black font-[550] block  w-full'>Subject Classes</h3>
                  <p className='text-sm text-gray-600'>Below are all the classes where this subject is taught</p>
                </div>

                <button onClick={()=>{setShowClasses(!showClasses)}} className='p-[10px] bg-gray-100 transition duration-200 text-xs font-medium flex items-center justify-center gap-x-[5px]'>
                  {showClasses ? 'Hide' : 'Show'} Classes
                  <ChevronIcon className={`w-4 h-4 transition duration-200 ${showClasses ? '-rotate-90' : '-rotate-180'}`} />
                </button>
              </div>
            </div>

            {showClasses && <>
              {subjectDetails?.classes?.map((subjectClass, subjectClassIndex) => (
                <div key={subjectClassIndex} className='w-full flex items-start gap-x-[10px] p-[20px] rounded-[8px] bg-gray-50 bg-opacity-70 my-[20px]'>
                  <div className='w-[100px]'>
                    <p className='text-black font-space-grotesk font-[500]'>{subjectClass?.class?.name}</p>
                  </div>
                  <div className='w-9/12'>
                    {!subjectClass.teachers || subjectClass.teachers.length === 0 ? <p className='text-gray-500 text-sm'>
                      No teachers assigned to teach this subject for this class yet. Click on "Assign Teacher" to assign. You can assign multiple teachers
                    </p> : 
                      <div className='w-full flex flex-wrap gap-x-[5px] gap-y-[5px]'>
                        {subjectClass.teachers.map((teacher, teacherIndex) => (
                          <div key={teacherIndex} className='p-[10px] rounded bg-gray-100 flex items-center justify-center gap-x-[10px]'>
                            <p className='text-xs text-gray-600'>{teacher.fullName}</p>
                            {removnigTeacher !== teacherIndex && <button className='transition duration-200' onClick={()=>{removeTeacherAssignment(teacherIndex, teacher._id, subjectClass.class._id)}}><TrashIcon className={`w-4 h-4 text-gray-400 hover:text-red-500`} /></button>}
                          </div>
                        ))}
                      </div>
                    }
                  </div>
                  
                  <div className='w-3/12 flex flex-row-reverse'>
                    <button onClick={()=>{openTeacherAssignment(subjectClass.class)}} className='px-[20px] py-[10px] bg-gray-200 rounded text-[12px] font-space-grotesk font-[550] transition duration-200 hover:bg-gray-300 hover:text-gray-600 flex items-center justify-center gap-x-[3px]'><PlusIcon className='w-4 h-4' /> Assign a teacher</button>
                  </div>
                </div>
              ))}
            </>}
          </div>

          <div className='w-full mb-[20px] pt-[20px] mt-[20px]'>
            <div className='flex items-start justify-between mb-[20px] pb-[10px] border-b border-gray-300'>
              <div className='w-2/3'>
                <h3 className='text-[15px] font-space-grotesk text-black font-[550] block  w-full'>Subject Assessments</h3>
                <p className='text-sm text-gray-600'>Below are assessment results recorded for this subject.</p>
              </div>
              <div className='flex flex-row-reverse'>
                <button onClick={()=>{setRecordingAssessment(true)}} className='rounded px-4 py-3 text-sm text-purple-100 bg-vcm-purple transition duration-200 border border-vcm-purple hover:bg-vcm-light-purple hover:text-vcm-purple flex items-center justify-center gap-x-2'>
                    Record Assessment
                </button>
              </div>
            </div>

            <div className='w-full flex items-center justify-between mt-2 p-2 rounded-md border mb-[40px]'>
              <div className='w-full'>
                <AssessmentsFilters applyFilters={(filters)=>{
                  console.log('filters => ', filters)
                  setAssessmentFilters(filters)
                }} 
                />
              </div>
              <div className='w-[30%] flex flex-row-reverse gap-x-2'>
                <button onClick={()=>{}} className={`text-gray-700 px-3 py-2 hover:bg-gray-100 transition duration-200 text-sm flex items-center justify-center gap-x-2 bg-gray-200 rounded border`}>
                  <ArrowUpTrayIcon className={`w-5 h-5`} />
                  Export Assessments Scores
                </button>
                {/* <div className='w-[350px]'>
                  <SearchField 
                    placeholderText={`Search for invoice by name or invoice code`}
                    showResultsDropDown={false}
                    triggerSearch={(term)=>{searchApplicants(term)}}
                    performingSearch={invoicesSelector.loadingInvoices}
                  />
                </div> */}
              </div>
            </div>

            {assessmentsSelector?.loadingAssessmentRecords ? 
              <Loader />
            :
            <>
              {assessmentsSelector?.assessmentRecords?.assessmentRecords?.length > 0 ? 
                <div className='w-full'>
                  <DataTable
                    tableHeaders={tableHeadersFields(cleanupData(assessmentsSelector?.assessmentRecords?.assessmentRecords)[0]).headers} 
                    tableData={cleanupData(assessmentsSelector?.assessmentRecords?.assessmentRecords)} 
                    columnWidths={transactionColumnWidths}
                    columnDataStyles={columnDataStyles}
                    allFields={tableHeadersFields(cleanupData(assessmentsSelector?.assessmentRecords?.assessmentRecords)[0]).fields}
                    onSelectItems={()=>{}}
                    tableOptions={tableOptions}
                    pagination={{
                        perPage: assessmentPaginaton.perPage, 
                        currentPage: assessmentPaginaton.page,
                        totalItems: assessmentsSelector?.assessmentRecords?.total,
                    }}
                    changePage={(page) => {setAssessmentPaginaton({...assessmentPaginaton, ...{page: page}})}}
                    updatePerPage={(perPage) => {setAssessmentPaginaton({...assessmentPaginaton, ...{perPage: perPage}})}}
                  />
                </div>
              :
                <div className='w-full'>
                  <EmptyState emptyStateText={`No assessments recorded for this subject yet. Teachers of this subject can record assessments for this subject by clicking on record assessment above.`} />
                </div>
              }
            </>}
          </div>
        </div>
      }

      <ModalDialog
        shown={updatingSubject} 
        closeFunction={()=>{setUpdatingSubject(false)}} 
        actionFunction={()=>{}} 
        actionFunctionLabel={``}
        dialogTitle={`Update subject - ${subjectDetails?.name}`}
        maxWidthClass='max-w-xl'
        hideActions={true}
      >
        <EditSubject 
          subject={subjectDetails}
          close={()=>{setUpdatingSubject(false)}}
        />
      </ModalDialog>

      {activeClass !== '' && <ModalDialog
        shown={assigningTeacher} 
        closeFunction={()=>{setUpdatingSubject(false)}} 
        actionFunction={()=>{}} 
        actionFunctionLabel={``}
        dialogTitle={`Add subject class teacher for ${activeClass.name} - ${subjectDetails?.name}`}
        maxWidthClass='max-w-xl'
        hideActions={true}
      >
        <ClassTeacherAssignment 
          subject={subjectDetails}
          activeClass={activeClass}
          close={()=>{closeTeacherAssignment()}}
          reload={()=>setReload(reload+1)}
        />
      </ModalDialog>}

      <ModalDialog
        shown={recordingAssessment} 
        closeFunction={()=>{setRecordingAssessment(false)}} 
        actionFunction={()=>{}} 
        actionFunctionLabel={``}
        dialogTitle={`Record student assessment for subject - ${subjectDetails?.name}`}
        maxWidthClass='max-w-xl'
        hideActions={true}
      >
        <RecordAssessment subject={subjectDetails} close={()=>{setRecordingAssessment(false)}} />
      </ModalDialog>
    </>
  )
}

export default SubjectDetails 